// packages/web/src/lib/mobile-nav.ts
export type MobileTab = 'chat' | 'workflows';

/** Resolve which mobile bottom-nav tab is active for a given pathname, or null. */
export function activeMobileTab(pathname: string): MobileTab | null {
  if (pathname === '/chat' || pathname.startsWith('/chat/')) return 'chat';
  if (pathname === '/workflows' || pathname.startsWith('/workflows/')) return 'workflows';
  return null;
}
